export const USER_UUID_COOKIE="USER_UUID_COOKIE_QUIZZ_EDGE"